import SArray from 's-array';
import { Entrypoints } from 'core/app/entrypoints';
import { IAjax } from 'lib/Ajax';
import TZDate from 'lib/TZDate';
import { maybeLoader } from 'lib/maybeLoader';

import { HomePageCruiseScheduleData, HomePageCruiseVisitData } from 'data/models/HomePage';
import { Measurement } from 'data/models/Measurement';

import { PortFilterer } from './model';

export const CruiseSchedule = (ajax : IAjax, portFilterer : PortFilterer, entrypoints : Entrypoints, shown : () => boolean) => {
    var cruises = SArray<HomepageCruiseScheduleViewModel>([]),
        displayedCruises = portFilterer(cruises, c => c.Data.PortName || ''),
        loader = maybeLoader(
            ajax,
            entrypoints.HomeCruise,
            (ds: HomePageCruiseScheduleData[]) => cruises(ds.map(d => new HomepageCruiseScheduleViewModel(d))),
            shown
        );

    return {
        Loading: loader.Loading,
        PortCruiseSchedules: displayedCruises
    }
}
export type CruiseSchedule = ReturnType<typeof CruiseSchedule>;

class HomepageCruiseScheduleViewModel {
    // Array of tuples like [ numeric year, array of cruise visits ]
    readonly CruiseVisitYears : [ year : number, visits : readonly CruiseVisitViewModel[] ][];

    constructor(readonly Data: HomePageCruiseScheduleData) {
        const
            cruiseVisits = (Data.CruiseVisits || []).map(v => new CruiseVisitViewModel(v)),
            // Use a Map to group cruise visits by year b/c...
            //  1) A Map is guaranteed to iterate entries in insertion order. The server gives
            //     us cruise visits in order by arrival date and then departure date, so we
            //     just wanna make sure to preserve that same order when grouping into years.
            //  2) A Map lets us use the numeric years as keys without being forced to stringify
            //     the years. That's nice, b/c it lets us treat stringifying the years (and
            //     choosing the format etc) as a view-layer concern.
            // In contrast, if we used a plain JS object to group cruise visits by year (or
            // used a utility like _.groupBy that's built on a plain JS object), then
            // iteration order would be more unpredictable (see https://stackoverflow.com/a/38218582)
            // and we'd be forced to stringify the years here instead of in our view layer.
            byYear = new Map<number, CruiseVisitViewModel[]>();

        for (let visit of cruiseVisits) {
            const year = visit.Arrival.getFullYear();
            (byYear.get(year) ?? setValue(byYear, year, [])).push(visit);
        }

        this.CruiseVisitYears = Array.from(byYear);
    }
}

// Map<K, V>.set returns the map (for method chaining). This function just returns the new
// value instead.
function setValue<K, V>(map : Map<K, V>, key : K, value : V) {
    map.set(key, value);
    return value;
}

class CruiseVisitViewModel {
    readonly Arrival: TZDate;
    readonly Departure: TZDate;
    readonly Length: Measurement;

    constructor(readonly Data: HomePageCruiseVisitData) {
        this.Arrival = new TZDate(Data.Arrival);
        this.Departure = new TZDate(Data.Deparature);
        this.Length = new Measurement(Data.Length);
    }

    DepartsOnSameDayAsArrival() {
        return this.Departure.getFullYear() === this.Arrival.getFullYear() &&
            this.Departure.getMonth() === this.Arrival.getMonth() &&
            this.Departure.getDate() === this.Arrival.getDate();
    }
}



// WEBPACK FOOTER //
// ./apps/portcall/homepage/cruiseschedule.ts